import {defineNuxtPlugin, useCookie} from '#app';
import {useBaseStore} from "~/stores/base";
import {getShippingAddress, globalUpdateUserInfo} from "~/utils/common";
import Cookies from "js-cookie";
import {PATH_ACCOUNT, PATH_SUBSCRIBE} from "~/utils/constants";
import {smartLookProperties} from "~/utils/smartlook";

export default defineNuxtPlugin(async () => {
  const isLogin = useBaseStore().getterIsLogin
  let cookieUserInfo
  if (process.server) {
    const cookie = useCookie("userInfo")
    cookieUserInfo = cookie.value
  }
  if (process.client) {
    cookieUserInfo = Cookies.get("userInfo")
  }
  console.log('[isLogin]', isLogin)
  console.log('[cookie userInfo]', cookieUserInfo)
  if (isLogin && cookieUserInfo) {
    if (process.client) {
      try {
        // 放弃下方逻辑，因为PLP需要用户信息，故索性全体阻塞
        /**
         * 按需阻塞页面进程
         * 需求在 route-guard.global.js
         * **/
        // const path = useRoute().path
        // switch (true) {
        //   case path.includes(PATH_ACCOUNT):
        //   case path.includes(PATH_SUBSCRIBE):
        // 阻塞
        await globalUpdateUserInfo()
        await getShippingAddress()
        // break;
        // default:
        //   非阻塞
        // globalUpdateUserInfo()
        // break;
        // }
      } catch (e) {
        console.error(e)
      }
    }
  } else {
    useBaseStore().updateIsLogin(false)
    if (process.client) {
      Cookies.remove("userInfo", {path: "/", domain: ".bnto.com"});
      /** 未登录 初始化 smartlook 全局参数 **/
      smartLookProperties()
    }
    if (process.server) {
      const cookie = useCookie("userInfo")
      cookie.value = null
    }
  }
});
